import { render, staticRenderFns } from "./SetupConclusao.vue?vue&type=template&id=6c6cb2c1&"
import script from "./SetupConclusao.vue?vue&type=script&lang=js&"
export * from "./SetupConclusao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports